/**
 * Google Play logo. Shared by the hero store badges and the /card QR slides so
 * the mark stays identical in both places.
 */
export default function GooglePlayIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 512 512" aria-hidden="true" className={className}>
      <path
        fill="#00F076"
        d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1z"
      />
      <path
        fill="#00A0FF"
        d="M47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0z"
      />
      <path
        fill="#FFBC00"
        d="M472.2 225.6l-58.9-34.1-65.7 65.5 65.7 65.5 60.1-34.1c18-14.3 18-46.5-1.2-62.8z"
      />
      <path
        fill="#FF3A44"
        d="M104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
      />
    </svg>
  );
}
